import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { Search, Play, Pause, Volume2, Download, Speaker, MoreVertical } from 'lucide-react'
import IslamRoadmap from '@/components/islam/IslamRoadmap'
import PreShahadaJourney from '@/components/islam/PreShahadaJourney'
import EnteringIslamSteps from '@/components/islam/EnteringIslamSteps'
import ShahadaBlessedSection from '@/components/islam/ShahadaBlessedSection'
import WelcomeMessage from '@/components/islam/WelcomeMessage'

export default function JourneyToIslamPage() {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language || 'ar'
  const isRTL = currentLang === 'ar'
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Helmet>
        <title>{t('journey.seo.title')} - {t('brand.name', 'Sakeena')}</title>
        <meta name="description" content={t('journey.seo.description')} />
        <meta name="keywords" content={t('journey.seo.keywords')} />
      </Helmet>

      {/* Main Container */}
      <div className="min-h-screen bg-white dark:bg-gray-900">
        {/* Hero Section - simplified to match reference */}
        <section className="relative py-8 md:py-10 lg:py-12">
          {/* Hero Section Container */}
          <div className="container mx-auto px-4 relative z-10 max-w-7xl">
            {/* White Card - text only */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-5 md:p-6 lg:p-8 shadow-md border border-gray-100 dark:border-gray-700">
              <div
                className={`text-sm text-gray-500 dark:text-gray-400 font-normal leading-relaxed mb-5 md:mb-6 ${isRTL ? 'text-right' : 'text-left'}`}
              >
                <span className="text-primary-600 dark:text-primary-400 font-medium">
                  {t('common.home', 'Home')}
                </span>
                <span className="text-gray-400 dark:text-gray-500"> / </span>
                <span>{t('journey.hero.badge', 'A blessed journey towards truth')}</span>
              </div>
              <h1
                className={`text-3xl md:text-4xl font-bold text-gray-900 dark:text-white leading-tight tracking-tight mb-4 md:mb-5 ${isRTL ? 'text-right' : 'text-left'}`}
              >
                {t('journey.hero.title', 'Journey to Islam')}
              </h1>
              <div className={`space-y-2.5 md:space-y-3 ${isRTL ? 'text-right' : 'text-left'}`}>
                <p className="text-base md:text-lg font-medium text-gray-800 dark:text-gray-200 leading-relaxed">
                  {t('journey.hero.subtitle2', 'Step by step, with ease')}
                </p>
                <p className="text-sm md:text-base font-medium text-gray-700 dark:text-gray-300 leading-relaxed">
                  {t('journey.hero.subtitle1', 'Your complete guide to learning about Islam and embracing it')}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Roadmap Section */}
        <IslamRoadmap />

        {/* Pre-Shahada Journey */}
        <PreShahadaJourney />

        {/* Last Three Cards Container - Figma Design */}
        <section className="py-8 md:py-10 lg:py-12 bg-white dark:bg-gray-900">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="bg-[#EAF7F2] dark:bg-gray-800 rounded-3xl" style={{ borderRadius: '24px', padding: '24px' }}>
              <div className="flex flex-col" style={{ gap: '20px' }}>
                {/* Entering Islam Steps */}
                <EnteringIslamSteps />

                {/* Shahada Blessed Section */}
                <ShahadaBlessedSection />

                {/* Welcome Message */}
                <WelcomeMessage />
              </div>
            </div>
          </div>
        </section>
      </div>

    </>
  )
}

